import { useState } from "react";
import axios from "axios";
import { LockKeyhole, LogIn, Mail, Phone } from "lucide-react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export default function AdminLogin() {
  const { user, setUser, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) return <Navigate to="/admin" replace />;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email.trim() || !password) {
      toast.error("Add meg az admin e-mail-címet és a jelszót.");
      return;
    }

    setSubmitting(true);
    try {
      const response = await axios.post(
        `${API}/auth/login`,
        { email: email.trim(), password },
        { withCredentials: true }
      );
      setUser(response.data);
      navigate("/admin", { replace: true });
    } catch (error) {
      const detail = error?.response?.data?.detail || "A bejelentkezés nem sikerült.";
      toast.error(detail);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--beige-50)] flex items-center justify-center px-5">
      <div className="tk-card max-w-md w-full p-8 sm:p-10">
        <div className="text-center">
          <Link to="/" className="inline-flex items-center gap-2 mb-6">
            <span className="w-10 h-10 rounded-full bg-[var(--burgundy)] text-white flex items-center justify-center">
              <Phone size={16} />
            </span>
            <span className="font-serif text-2xl">Telefonka</span>
          </Link>
          <h1 className="font-serif text-3xl text-[var(--ink)]">Admin bejelentkezés</h1>
          <p className="mt-3 text-[var(--ink-soft)] text-sm leading-relaxed">
            A hozzáférés csak az engedélyezett admin e-mail-címmel lehetséges.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="mt-7 space-y-4">
          <div>
            <label htmlFor="admin-email" className="block text-xs uppercase tracking-widest text-[var(--ink-soft)] mb-2">
              <Mail size={12} className="inline mr-1" /> E-mail-cím
            </label>
            <input
              id="admin-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="username"
              className="tk-input"
              placeholder="admin@telefonka.hu"
              required
            />
          </div>

          <div>
            <label htmlFor="admin-password" className="block text-xs uppercase tracking-widest text-[var(--ink-soft)] mb-2">
              <LockKeyhole size={12} className="inline mr-1" /> Jelszó
            </label>
            <input
              id="admin-password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              className="tk-input"
              required
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-password-login"
            className="tk-btn-primary justify-center w-full disabled:opacity-60"
          >
            <LogIn size={16} />
            {submitting ? "Bejelentkezés…" : "Bejelentkezés"}
          </button>
        </form>

        <Link to="/" className="block mt-5 text-center text-xs uppercase tracking-widest tk-link-soft">
          ← Vissza a főoldalra
        </Link>
      </div>
    </div>
  );
}
